import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import SplashScreen from "@/components/SplashScreen";
import HomePage from "@/pages/HomePage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const hide = () => {
      const b = document.getElementById("emergent-badge");
      if (b) {
        b.style.setProperty("display", "none", "important");
        b.style.setProperty("visibility", "hidden", "important");
      }
    };
    hide();
    const id = setInterval(hide, 100);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="App">
      <AnimatePresence mode="wait">
        {showSplash && (
          <SplashScreen key="splash" onComplete={() => setShowSplash(false)} />
        )}
      </AnimatePresence>
      {!showSplash && (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
